import React from 'react';

import { SubscriberCouncilPartner } from '../../utils/backend-api/partners';
import { isExternalURL } from '../../utils/url_validations';
import { Button } from '../BaseUI';

interface SubscriberCouncilCardProps {
  partner: SubscriberCouncilPartner;
}

const SubscriberCouncilCard = ({ partner }: SubscriberCouncilCardProps) => {
  const { id, name, tagline, targetLink } = partner;
  const externalLinkAttributes = isExternalURL(targetLink, window.location)
    ? { target: '_blank', rel: 'sponsored' }
    : {};

  return (
    <div className="text-zinc-800 text-[14px] font-['Meta',Georgia,sans-serif] pl-12 py-3 mb-8 border-0 border-l border-[#c4c6ce] border-solid">
      <Button
        href={targetLink}
        variant="link"
        trackClick
        trackingProps={{
          name: 'csc_card',
          identifier: id.toString(),
        }}
        {...externalLinkAttributes}
      >
        {name}: {tagline}
      </Button>
    </div>
  );
};

export default SubscriberCouncilCard;
